<template>
  <div class="container company__land">
    <div class="company__wrp">
      <img class="company__logo" src="/dist/assets/front_white/img/autodesk/civil@2x.png" />
      <bim-text-h5 tag="h1" class="title" bold>Каталоги Civil 3D</bim-text-h5>
    </div>

    <search-block
      searchPlaceholder="Поиск по библиотеке моделей Civil 3D"
      :attributeNumber="598"
    />
  </div>
</template>

<script>
  import bimTextH5 from '@bimlib/components/bimTextH5'
  import bimTextMain from '@bimlib/components/bimTextMain'
  import bimTextAccent from '@bimlib/components/bimTextAccent'
  import SearchBlock from './components/search-block'

  export default {
    name: 'Autodesk',
    components: {
      bimTextH5,
      bimTextMain,
      bimTextAccent,
      SearchBlock
    }
  }
</script>

<style lang="scss" scoped>
  @import "./src/front_white/sass/components/settings";

  .company__land {
    min-height: 700px;
  }

  .company__wrp {
    padding: 64px 0;
    text-align: center;
    color: $black-color;
  }

  .company__logo {
    width: 72px;
    height: 72px;
    margin: 0 auto;
  }

  .title {
    margin-top: 14px;
    font-size: 32px;
  }


  .description {
    margin-top: 17px;
  }

  .bim__20 {
    width: 20px;
    margin-right: 10px;
  }

  @media all and (max-width: $breakpoint-sm) {
    .company__wrp {
      padding: 40px 0;
    }
  }

</style>
